import axios, { AxiosInstance } from 'axios';
import { apiTokenURL, mockAndDevelopment } from '../../app.config';

const apiTokenClient: AxiosInstance = mockAndDevelopment()
  ? axios.create()
  : axios.create({
      baseURL: apiTokenURL(),
      headers: {
        accept: '*/*',
        contentType: 'application/json',
      },
      paramsSerializer: {
        indexes: null,
      },
    });

export default apiTokenClient;
